import { render } from "./TzRequireAuth.vue?vue&type=template&id=7a70b179&scoped=true"
import script from "./TzRequireAuth.vue?vue&type=script&lang=js"
export * from "./TzRequireAuth.vue?vue&type=script&lang=js"

import "./TzRequireAuth.vue?vue&type=style&index=0&id=7a70b179&lang=less&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/collections/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a70b179"]])

export default __exports__